<template>
    <div class="z-10">
        <PageComponent 
            :loader="loader" @showLoader="showLoader" @hideLoader="hideLoader"
            :addButtonLabel="addButtonLabel"
            @handleAddNew="addNewJournal"
            :searchFilters="searchFilters"
            :dropdownOptions="dropdownOptions"
            @handleDynamicOption="handleDynamicOption"
            @searchPage="searchJournals"
            @resetFilters="resetFilters"
            @removeItem="removeJournal"
            @removeSelectedItems="removeJournals"
            @printList="printJournalsList"
            v-model:printModalVisible="printModalVisible"
            :printTitle="printTitle"
            :pdfUrl="pdfUrl"
            :addingRight="addingRight"
            :removingRight="removingRight"
            :rightsModule="rightsModule"
            :columns="tableColumns"
            :rows="journalsList"
            :actions="actions"
            :showTotals="showTotals"
            :idField="idField"
            :enableContextMenu=true
            @handleSelectionChange="handleSelectionChange"
            @handleActionClick="handleActionClick"
            @handleRightClick="handleRightClick"
            @handleShowDetails="handleShowDetails"
            :count="propCount"
            :currentPage="currentPage"
            :result="propArrLen"
            @loadPrev="loadPrev"
            @loadNext="loadNext"
            @firstPage="firstPage"
            @lastPage="lastPage"
            :showNextBtn="showNextBtn"
            :showPreviousBtn="showPreviousBtn"
            :selectedValue="selectedValue"
            @selectSearchQuantity="selectSearchQuantity"
            :showDetails="showDetails"
            :detailsTitle="detailsTitle"
            @hideDetails="hideDetails"
            >
            <div>
                <div class="tabs pt-2">
                    <button v-for="(tab, index) in tabs" :key="tab" :class="['tab', { active: activeTab === index }]"@click="selectTab(index)">
                        {{ tab }}
                    </button>
                </div>
                <div class="tab-content mt-3">
                    <div v-if="activeTab == 0">
                        <JournalEntries 
                            :detailRows="journalEntries"
                        />
                    </div>
                </div>
                
            </div>
        </PageComponent>
        <MovableModal v-model:visible="invModalVisible" :title="title" :modal_top="modal_top" :modal_left="modal_left" :modal_width="modal_width"
            :loader="modal_loader" @showLoader="showModalLoader" @hideLoader="hideModalLoader" @closeModal="closeModal"
        >
            <DynamicForm 
                :fields="formFields" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" 
                :displayButtons="displayButtons" @handleSubmit="updateJournal" @handleReset="handleReset"
            />
        </MovableModal>
    </div>
</template>

<script>
import axios from "axios";
import { ref, computed, onMounted, onBeforeMount, watch} from 'vue';
import PageComponent from '@/components/PageComponent.vue';
import MovableModal from '@/components/MovableModal.vue';
import JournalEntries from "@/components/JournalEntries.vue";
import DynamicForm from '../NewDynamicForm.vue';
import { useStore } from "vuex";
import { useToast } from "vue-toastification";
import { useDateFormatter } from '@/composables/DateFormatter';
import PrintJS from 'print-js';

export default{
    name: 'Journals',
    components:{
        PageComponent, MovableModal,DynamicForm,JournalEntries
    },
    setup(){
        const store = useStore();     
        const toast = useToast();
        const { getYear } = useDateFormatter();
        const { getMonth } = useDateFormatter();
        const addingRight = ref('Adding Journal');
        const removingRight = ref('Deleting Journal');
        const rightsModule = ref('Accounts');
        const loader = ref('none');
        const modal_loader = ref('none');
        const idField = 'journal_id';
        const addButtonLabel = ref('New Journal');
        const submitButtonLabel = ref('Add');
        const title = ref('Updating Journal Amount');
        const detailsTitle = ref('Item Details');
        const tabs = ref(['Journal Entries']);
        const activeTab = ref(0);
        const invoiceID = ref(null);
        const invModalVisible = ref(false);
        const printModalVisible = ref(false);
        const pdfUrl = ref(null);
        const printTitle = ref('Print Journals');
        const modal_top = ref('150px');
        const modal_left = ref('400px');
        const modal_width = ref('32vw');
        const selectedIds = ref([]);
        const journalsList = ref([]);
        const propResults = ref([]);
        const propArrLen = ref(0);
        const propCount = ref(0);
        const pageCount = ref(0);
        const selectedValue = ref(50);
        const showDetails = ref(false);
        const journalEntries = ref([]);
        const currentPage = ref(1);
        const showNextBtn = ref(false);
        const showPreviousBtn = ref(false);
        const propModalVisible = ref(false);
        const flex_basis = ref('');
        const flex_basis_percentage = ref('');
        const displayButtons = ref(true);
        const errors = ref([]);
        const jnlID = ref('');
        const showModal = ref(false);
        const tableColumns = ref([
            {type: "checkbox"},
            {label: "Journal#", key:"journal_no"},
            {label: "Date", key: "issue_date"},
            {label: "Description", key:"description"},
            {label: "Amount", key:"total_amount", type:"number"},
            {label: "Done By", key:"done_by"},
        ])
        const showTotals = ref(true);
        const actions = ref([
            {name: 'delete', icon: 'fa fa-trash', title: 'Delete Journal', rightName: 'Deleting Journal'},
        ])
        const companyID = computed(()=> store.state.userData.company_id);
        const userID = computed(()=> store.state.userData.user_id);
        const journal_no_search = computed({
            get: () => store.state.Journals.journal_no_search,
            set: (value) => store.commit('Journals/SET_SEARCH_FILTERS', {"journal_no_search":value}),
        });
        const description_search = computed({
            get: () => store.state.Journals.description_search,
            set: (value) => store.commit('Journals/SET_SEARCH_FILTERS', {"description_search":value}),
        });
        const min_amount_search = computed({
            get: () => store.state.Journals.min_amount_search,
            set: (value) => store.commit('Journals/SET_SEARCH_FILTERS', {"min_amount_search":value}),
        });
        const max_amount_search = computed({
            get: () => store.state.Journals.max_amount_search,
            set: (value) => store.commit('Journals/SET_SEARCH_FILTERS', {"max_amount_search":value}),
        });
        const from_date_search = computed({
            get: () => store.state.Journals.from_date_search,
            set: (value) => store.commit('Journals/SET_SEARCH_FILTERS', {"from_date_search":value}),
        });
        const to_date_search = computed({
            get: () => store.state.Journals.to_date_search,
            set: (value) => store.commit('Journals/SET_SEARCH_FILTERS', {"to_date_search":value}),
        });
        const searchFilters = ref([
            {type:'text', placeholder:"Journal No...", value: journal_no_search, width:36},
            {type:'text', placeholder:"Description...", value: description_search, width:64},
            {type:'date', placeholder:"From Date...", value: from_date_search, width:36, title: "Date From Search"},
            {type:'date', placeholder:"To Date...", value: to_date_search, width:36, title: "Date To Search"},
            {type:'text', placeholder:"Min Amount...", value: min_amount_search, width:36},
            {type:'text', placeholder:"Max Amount...", value: max_amount_search, width:36},
        ]);
        const handleSelectionChange = (ids) => {
            selectedIds.value = ids;
        };
        
        const formFields = ref([]);
        const updateFormFields = () =>{
            formFields.value = [
                { type: 'number', name: 'total_amount',label: "Amount", value: 0, required: true},                
            ]
        };

        const handleReset = async() =>{
            for(let i=0; i < formFields.value.length; i++){
                formFields.value[i].value = '';
            }

        }
        
        const showModalLoader = () =>{
            modal_loader.value = "block";
        }
        const hideModalLoader = () =>{
            modal_loader.value = "none";
        }
        const addNewJournal = () =>{
            store.commit('pageTab/ADD_PAGE', {'FA':'Journal_Details'});
            store.state.pageTab.faActiveTab = 'Journal_Details'; 
        }
        const removeJournal = async() =>{
            if(selectedIds.value.length == 1){
                let formData = {
                    company: companyID.value,
                    journal: selectedIds.value,
                    txn_type: "JNL",
                    user: userID.value
                }
                try{
                    const response = await store.dispatch('Journals/deleteJournal',formData)
                    if(response && response.status == 200){
                        toast.success("Journal Removed Succesfully");
                        searchJournals();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Journal: ' + error.message);
                }
                finally{
                    selectedIds.value = [];
                    searchJournals();
                }
            }else if(selectedIds.value.length > 1){
                toast.error("You have selected more than 1 Journal") 
            }else{
                toast.error("Please Select A Journal To Remove")
            }
        }
        const removeJournals = async() =>{
            if(selectedIds.value.length){
                let formData = {
                    company: companyID.value,
                    journal: selectedIds.value,
                    txn_type: "JNL",
                    user: userID.value
                }

                try{
                    const response = await store.dispatch('Journals/deleteJournal',formData)
                    if(response && response.msg == "Success"){
                        toast.success("Journal(s) Removed Succesfully");
                        searchJournals();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Journals: ' + error.message);
                }
                finally{
                    selectedIds.value = [];
                    searchJournals();
                }
            }else{
                toast.error("Please Select A Journal To Remove")
            }
        }
        const showLoader = () =>{
            loader.value = "block";
        }
        const hideLoader = () =>{
            loader.value = "none";
        }
        const searchJournals = () =>{
            showLoader();
            showNextBtn.value = false;
            selectedIds.value = [];
            showPreviousBtn.value = false;
            let formData = {
                description: description_search.value,
                txn_type: "JNL",
                status: "",
                client: "",
                reference_no: "",
                payment_method: "",
                journal_no: journal_no_search.value,
                min_amount: min_amount_search.value,
                max_amount: max_amount_search.value,
                date_from: from_date_search.value,
                date_to: to_date_search.value,
                client_category: "",
                company_id: companyID.value,
                page_size: selectedValue.value
            } 
   
            axios
            .post(`api/v1/journals-search/?page=${currentPage.value}`,formData)
            .then((response)=>{
                journalsList.value = response.data.results;
                store.commit('Journals/LIST_JOURNALS', journalsList.value)
                propResults.value = response.data;
                propArrLen.value = journalsList.value.length;
                propCount.value = propResults.value.count;
                pageCount.value = Math.ceil(propCount.value / selectedValue.value);
                if(response.data.next){
                    showNextBtn.value = true;
                }
                if(response.data.previous){
                    showPreviousBtn.value = true;
                }
            })
            .catch((error)=>{
                console.log(error.message);
            })
            .finally(()=>{
                hideLoader();
            })
        };
        const selectSearchQuantity = (newValue) =>{
            selectedValue.value = newValue;
            searchJournals(selectedValue.value);
        };
        const resetFilters = () =>{
            currentPage.value = 1;
            store.commit('Journals/RESET_SEARCH_FILTERS')
            searchJournals();
        }
        const loadPrev = () =>{
            if (currentPage.value <= 1){
                currentPage.value = 1;
            }else{
                currentPage.value -= 1;
            }
            
            searchJournals();
            // scrollToTop();
        }
        const loadNext = () =>{
            if(currentPage.value >= pageCount.value){
                currentPage.value = pageCount.value;
            }else if(currentPage.value < pageCount.value){
                currentPage.value += 1;
            }
            
            searchJournals();
            // scrollToTop(); 
        }
        const firstPage = ()=>{
            currentPage.value = 1;
            searchJournals();
            // scrollToTop();
        }
        const lastPage = () =>{
            currentPage.value = pageCount.value;
            searchJournals();
            // scrollToTop();
        }
        const handleActionClick = async(rowIndex, action, row) =>{
            if(action == 'delete'){
                const journalID = [row['journal_id']];
                let formData = {
                    company: companyID.value,
                    journal: journalID,
                    txn_type: "JNL",
                    user: userID.value
                }
                await store.dispatch('Journals/deleteJournal',formData)
                searchJournals();
            }else if(action == 'edit'){
                const reconJnl = row['is_reconciled'];
                jnlID.value = row['journal_id'];
                if(reconJnl){
                    toast.error("Cannot Edit Reconciled Journal");
                    return;
                }
                updateFormFields();
                title.value = row['journal_no'];
                invModalVisible.value = true;
            }
        };
        watch(() => store.state.contextMenu.selectedAction, (actionPayload) => {
            if (!actionPayload) return;

            const { rowIndex, action, data } = actionPayload;

            handleActionClick(rowIndex, action, data);

            store.commit('contextMenu/CLEAR_SELECTED_ACTION');
        });
        
        const handleRightClick = (row, rowIndex, event) => {

            const menuOptions = [
                { label: 'Update Amount', action: 'edit', rowIndex: rowIndex , icon: 'fa fa-edit', rightName: 'Deleting Journal'},
                { label: 'Delete', action: 'delete', rowIndex: rowIndex, icon: 'fa fa-trash', rightName: 'Deleting Journal' },
            ];

            store.commit('contextMenu/SHOW_CONTEXT_MENU', {
                x: event.clientX,
                y: event.clientY,
                options: menuOptions,
                contextData: row,
            });
        };
        const updateJournal = async() =>{
            showModalLoader();
            let formData = {
                journal: jnlID.value,
                total_amount: formFields.value[0].value,
                company: companyID.value
            }
            if(formFields.value[0].value <= 0){
                toast.error("Invalid Amount");
                hideModalLoader();
                return;
            }
            try{
                const response = await axios.post('api/v1/update-journal-amount/',formData)
                if(response && response.data.msg == "Success"){
                    toast.success("Journal Updated Succesfully");
                    invModalVisible.value = false;
                    handleReset();
                    searchJournals();
                }
                else if(response && response.data.msg == "Reconciled"){
                    toast.error("Cannot Update Reconciled Journal!");
                }
            }
            catch(error){
                console.error(error.message);
                toast.error('Failed to update Journal: ' + error.message);
            }
            finally{
                hideModalLoader();
                handleReset();
                searchJournals();
            }
        };
        const handleShowDetails = async(row) =>{
            activeTab.value = 0;
            invoiceID.value = row['journal_id'];
            detailsTitle.value = row['journal_no'] + ' Details';
            showDetails.value = true;
            let formData = {
                journal: row['journal_id'],
                company: companyID.value
            }
            axios.post('api/v1/journal-entries-search/',formData)
            .then((response)=>{
                journalEntries.value = response.data.journal_entries;
            })
            .catch((error)=>{
                console.log(error.message)
            })
        };
        const selectTab = async(index) => {
            let formData = {
                company: companyID.value,
                journal: invoiceID.value,
            }
                activeTab.value = index;
                hideLoader();
        };
        const hideDetails = async() =>{
            showDetails.value = false;
        };
        const closeModal = async() =>{
            invModalVisible.value = false;
            handleReset();
        }

        const dropdownOptions = ref([
            // {label: 'Withholding Tax', action: 'withholding-tax'},
        ]);
        const handleDynamicOption = (option) =>{
            if(option == 'batch-meter-reading'){
                store.commit('pageTab/ADD_PAGE', {'PMS':'Batch_Readings'})
                store.state.pageTab.faActiveTab = 'Batch_Readings';
            }
        };
        const printJournalsList = () =>{
            showLoader();

            let formData = {
                description: description_search.value,
                txn_type: "JNL",
                status: "",
                client: "",
                reference_no: "",
                payment_method: "",
                journal_no: journal_no_search.value,
                min_amount: min_amount_search.value,
                max_amount: max_amount_search.value,
                date_from: from_date_search.value,
                date_to: to_date_search.value,
                client_category: "",
                company_id: companyID.value
            }
            axios
            .post("api/v1/export-journals-pdf/", formData, { responseType: 'blob' })
            .then((response)=>{
                if(response.status == 200){
                    const blob1 = new Blob([response.data], { type: 'application/pdf' });
                    const url = URL.createObjectURL(blob1);
                    // PrintJS({printable: url, type: 'pdf'});
                    pdfUrl.value = url;
                    printModalVisible.value = true;
                }
            })
            .catch((error)=>{
                console.log(error.message);
            })
            .finally(()=>{
                hideLoader();
            })
        }
        onBeforeMount(()=>{
            searchJournals();
            
        })
        return{
            showTotals,title, searchJournals,resetFilters, addButtonLabel, searchFilters, tableColumns, journalsList,printModalVisible,pdfUrl, printTitle,
            currentPage,propResults, propArrLen, propCount, pageCount, showNextBtn, showPreviousBtn,invModalVisible,
            loadPrev, loadNext, firstPage, lastPage, idField, actions, handleActionClick,handleRightClick, propModalVisible, closeModal,
            submitButtonLabel, showModal, showLoader, loader, hideLoader, modal_loader, modal_top, modal_left, modal_width,displayButtons,
            showModalLoader, hideModalLoader, formFields, handleSelectionChange, flex_basis,flex_basis_percentage,
            removeJournal, removeJournals, dropdownOptions, handleDynamicOption, addNewJournal, printJournalsList,addingRight,removingRight,rightsModule,
            selectSearchQuantity,selectedValue,showDetails,detailsTitle,hideDetails,handleShowDetails,journalEntries,tabs,selectTab,activeTab,
            updateJournal
        }
    }
};
</script>


<style scoped>
.tabs {
    display: flex;
    border-bottom: 1px solid #ccc;
}
.tab {
    padding: 2px 20px 2px 20px;
    cursor: pointer;
}

.tab.active {
    border-bottom: 2px solid #000;
}

.tab-content {
    padding: 1px;
}</style>